import { ENTITY_URL } from "../../../config/config";
import { connection } from "../../../utils/connection";

const obtenerListadoPersonasInterno = async ({ token, callbacks }) => {
    const response = await connection({ method: 'GET', url: `${ENTITY_URL.PERSONA.LIST_INTERNAL}`, extraHeaders: { token: token } });;
    if (typeof callbacks === "function") {
        callbacks(response);
    }
}
export default obtenerListadoPersonasInterno;